import {Injectable} from '@angular/core'
import {BehaviorSubject, concat, firstValueFrom, forkJoin, lastValueFrom, Observable} from 'rxjs'
import {Media} from '../../../components/vendor.items/add.edit/steps/interfaces/s4'
import {environment} from '../../../../environments/environment'
import {HttpClient} from '@angular/common/http'
import {switchMap, toArray} from 'rxjs/operators'
import {NotificatorService} from '../../services/notificator.service'
import {NzUploadFile} from 'ng-zorro-antd/upload'
import {GGBase} from './global-gallery/gg.interface'

@Injectable({
    providedIn: 'root'
})
export class ImageEditorService {
    private fileSelectedSrc = new BehaviorSubject<string | null>(null)
    public subscriptOnFile$: Observable<string | null> = this.fileSelectedSrc.asObservable()

    constructor(
        private http: HttpClient,
        private notify: NotificatorService
    ) {
    }

    // Subscription on change global uploaded file
    public setFile(file: string | null, showMessage?: boolean): void {
        console.log('--IES-set-file: ', {file})
        if (file !== null && showMessage) {
            this.notify.createNotification('info', 'Info',
                'The uploaded image has been added to each step. You can change it in the editor.', 10)
        }
        this.fileSelectedSrc.next(file)
    }

    public calcRatio(ratio: string): number {
        return +ratio.split(':')[0] / +ratio.split(':')[1]
    }

    // resizeImageFile(file: File, maxWidth: number, maxHeight: number): Promise<string> {
    //   return new Promise((resolve, reject) => {
    //     const reader = new FileReader()
    //     reader.readAsDataURL(file)
    //     reader.onload = (event) => {
    //       const img = new Image()
    //       img.src = event.target?.result as string
    //       img.onload = () => {
    //         const canvas = document.createElement('canvas')
    //         let width = img.width
    //         let height = img.height
    //
    //         // Calculate aspect ratio
    //         if (width > height) {
    //           if (width > maxWidth) {
    //             height *= maxWidth / width
    //             width = maxWidth
    //           }
    //         } else {
    //           if (height > maxHeight) {
    //             width *= maxHeight / height
    //             height = maxHeight
    //           }
    //         }
    //
    //         canvas.width = width
    //         canvas.height = height
    //         const ctx = canvas.getContext('2d')
    //         ctx?.drawImage(img, 0, 0, width, height)
    //
    //         // Return as Base64 (or use canvas.toBlob for a File object)
    //         resolve(canvas.toDataURL('image/jpeg', 0.92))
    //       }
    //     }
    //     reader.onerror = (error) => reject(error)
    //   })
    // }

    public resizeImageBase64(image: string, toWidth: number, ratio?: number, tags?: string[]): Promise<any> {
        return new Promise((resolve, reject) => {
            const img = new Image()
            img.src = image
            img.onload = () => {
                const canvas = document.createElement('canvas')
                let width = img.width
                let height = img.height

                // Calculate aspect ratio
                width = toWidth
                height = width / ((ratio) ? ratio : (img.width / img.height))

                canvas.width = width
                canvas.height = height
                const ctx = canvas.getContext('2d')
                ctx?.drawImage(img, 0, 0, width, height)

                if (tags) {
                    resolve({
                        img: canvas.toDataURL('image/jpeg', 0.92),
                        tags
                    })
                } else {
                    resolve(canvas.toDataURL('image/jpeg', 0.92))
                }
            }
            img.onerror = (error) => reject(error)
        })
    }

    public uploadImage(
        event: { file: NzUploadFile, type: string },
        dimensions: {
            minSize: number,
            minSizeToResize: number
        }
    ): Promise<HTMLImageElement> {
        return new Promise((resolve, reject) => {

            const image = new Image()
            let file = null
            if (event) {
                if (event.type === 'start') {
                    file = event.file!.originFileObj!
                } else {
                    reject(null)
                }
            }
            if (!file) {
                reject(null)
            }
            const reader = new FileReader()
            reader.onload = () => {
                const result = reader.result
                // console.log('file loaded: ', result)
                if (typeof result !== 'string') {
                    return
                }
                image.src = result
                image.onload = () => {
                    // Check uploaded image on min size
                    if (image.width < dimensions.minSize && image.width >= dimensions.minSizeToResize) {
                        this.notify.confirmModal('Do resize?',
                            'The uploaded image is smaller than the standard width, but the image has the minimum allowed size deviation. Resize?',
                            {ok: 'Yes', cancel: 'No'}).then(yes => {

                            // Resizing
                            // let ratio
                            // if (this.wizardMode) {
                            //   ratio = this.IES.calcRatio(this.handleSteps[this.step].ratio)
                            // } else {
                            //   ratio = this.IES.calcRatio(this.currentHandle.ratio)
                            // }
                            const ratio = image.width / image.height
                            this.resizeImageBase64(image.src, dimensions.minSize, ratio).then(newImg => {
                                const newImage = new Image()
                                newImage.src = newImg
                                newImage.onload = () => {
                                    console.log('resized: ', newImage.width)
                                    resolve(newImage)
                                    // this.IES.setFile(newImage.src)
                                    // if (this.wizardMode) {
                                    //   this.handleSteps.forEach(i => {
                                    //     i.imageExists = true
                                    //   })
                                    // } else {
                                    //   this.currentHandle.imageExists = true
                                    // }
                                }
                            }, error => {
                                this.notify.createTopMessage('Unable to resize this image', 'error', 2000)
                                reject(null)
                            })
                        }, no => {
                            // no resize
                            reject(null)
                        })
                    } else {
                        if (image.width < dimensions.minSize) {
                            this.notify.createModalNotification('Incompatible size',
                                `You Uploaded image with size: ${image.width}x${image.height}px. but it's too small for this image-type.\nMinimal image width should be ${dimensions.minSize}px.`,
                                'error')
                            reject(null)
                        } else {
                            // no errors - load image
                            // If no errors - load image as global
                            resolve(image)
                        }
                    }
                }
                // Send image to editor
                // this.editor.onFileSelected(null, null, result)
                // this.editionFile?.contentId = image.src
            }
            reader.readAsDataURL(file)
        })
    }

    // private  resizeImageToBase64(file: File, maxWidth: number = 2400): Promise<string> {
    //   return new Promise((resolve, reject) => {
    //     const reader = new FileReader();
    //
    //     reader.onload = () => {
    //       const img = new Image();
    //
    //       img.onload = () => {
    //         const ratio = img.width > maxWidth ? maxWidth / img.width : 1;
    //         const width = Math.round(img.width * ratio);
    //         const height = Math.round(img.height * ratio);
    //
    //         const canvas = document.createElement('canvas');
    //         canvas.width = width;
    //         canvas.height = height;
    //
    //         const ctx = canvas.getContext('2d');
    //         if (!ctx) {
    //           reject(new Error('Canvas context error'));
    //           return;
    //         }
    //
    //         ctx.drawImage(img, 0, 0, width, height);
    //         resolve(canvas.toDataURL('image/jpeg', 0.85));
    //       };
    //
    //       img.onerror = () => reject(new Error('Image load error'));
    //       img.src = reader.result as string;
    //     };
    //
    //     reader.onerror = () => reject(new Error('File read error'));
    //     reader.readAsDataURL(file);
    //   });
    // }

    // Add / Edit / Remove
    public addImage(
        type: 'VIDEO' | 'IMAGE' | string = 'IMAGE',
        content: string,
        category: string | number,
        vendorId: string | number,
        tags: string[]
    ) {
        // console.log('try save image: ', TS)
        // console.log('content length:', content?.length)
        // console.log('payload keys:', Object.keys(TS))
        // console.log('payload size approx (chars):', JSON.stringify(TS).length)
        return new Promise<Media>((resolve, reject) => {
            // this.resizeImageBase64(content, 1400).then(resizedImage => {
            //   console.log('RESIZED: ', {
            //     before: content?.length,
            //     after: resizedImage.length,
            //     old: content,
            //     new: resizedImage
            //   })
            //   const TS = {type, resizedImage, category, tags}
            const TS = {type, content, category, tags}
            this.http.post<Media>(`${environment.apiPrefix}/vendor/${category}/${vendorId}/gallery`, TS)
                .subscribe((res) => {
                    resolve(res)
                }, error => {
                    reject(error)
                })
            // })
        })
    }

    public addImageBatch(
        images: { img: string; tags: string[] }[],
        category: string | number,
        vendorId: string | number,
    ): Promise<Media[]> {
        // console.log('try save images: ', images)
        const requests = images.map(file =>
            this.addImage('IMAGE', file.img, category, vendorId, file.tags)
        )
        return lastValueFrom(
            concat(...requests).pipe(toArray())
        )

    }

    public removeImage(
        contentId: number,
        category: string | number,
        vendorId: string | number,
    ): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.http.delete(`${environment.apiPrefix}/vendor/${category}/${vendorId}/gallery/${contentId}`)
                .subscribe(() => {
                    resolve(true)
                }, error => {
                    reject()
                })
        })
    }

    public removeBatch(fileIds: number[], category: string | number, vendorId: string | number): Promise<boolean[]> {
        return new Promise((resolve, reject) => {
            const operations = fileIds.map(file => {
                return this.removeImage(file, category, vendorId)
            })
            forkJoin(operations).subscribe(ok => {
                resolve(ok)
            }, error => {
                reject(error)
            })
        })
    }

    public getImageAsBase64(relativePath: string): Observable<string> {
        const fullUrl = `${window.location.origin}${relativePath}`
        return this.http.get(fullUrl, {responseType: 'blob'}).pipe(
            switchMap((blob: Blob) => {
                return new Observable<string>((observer) => {
                    const reader = new FileReader()
                    reader.onloadend = () => {
                        observer.next(reader.result as string)
                        observer.complete()
                    }
                    reader.onerror = (error) => {
                        observer.error(error)
                    }
                    reader.readAsDataURL(blob)
                })
            })
        )
    }


    // GLOBAL GALLERY
    public getGlobalGallery(category?: string): Promise<GGBase[]> {
        category = environment.categoryDec2Str(category).api
        return new Promise((resolve, reject) => {
            const ep = (category) ?
                `${environment.apiPrefix}/vendor/gallery/all/${category}` :
                `${environment.apiPrefix}/vendor/gallery/all`
            this.http.get<GGBase[]>(ep).subscribe((gallery) => {
                resolve(gallery)
            }, error => {
                reject()
            })
        })
    }

}
